/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelineBookingServiceRsDto
 */
export interface TravelineBookingServiceRsDto {
    /**
     * Service ID
     * @type {string}
     * @memberof TravelineBookingServiceRsDto
     */
    id: string;
    /**
     * Name
     * @type {string}
     * @memberof TravelineBookingServiceRsDto
     */
    name: string;
    /**
     * Description
     * @type {string}
     * @memberof TravelineBookingServiceRsDto
     */
    description: string;
    /**
     * Cost of service<br />
     * @type {number}
     * @memberof TravelineBookingServiceRsDto
     */
    price: number;
}

/**
 * Check if a given object implements the TravelineBookingServiceRsDto interface.
 */
export function instanceOfTravelineBookingServiceRsDto(value: object): value is TravelineBookingServiceRsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function TravelineBookingServiceRsDtoFromJSON(json: any): TravelineBookingServiceRsDto {
    return TravelineBookingServiceRsDtoFromJSONTyped(json, false);
}

export function TravelineBookingServiceRsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingServiceRsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'price': json['price'],
    };
}

  export function TravelineBookingServiceRsDtoToJSON(json: any): TravelineBookingServiceRsDto {
      return TravelineBookingServiceRsDtoToJSONTyped(json, false);
  }

  export function TravelineBookingServiceRsDtoToJSONTyped(value?: TravelineBookingServiceRsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'price': value['price'],
    };
}

